export class ImageUtil {

    public static makeInitialImage = (name: string) => {
        const canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        canvas.width = 32;
        canvas.height = 32;
        document.body.appendChild(canvas);
        const context = canvas.getContext('2d');

        if (context) {
            const generateVibrantColorFromName = (name: string) => {
                let hash = 0;
                for (let i = 0; i < name.length; i++) {
                    hash = name.charCodeAt(i) + ((hash << 5) - hash);
                }

                const hue = Math.abs(hash) % 360;
                const saturation = 90;
                const lightness = 50;

                return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
            };

            const split = name.split(' ');
            const initials = split.length > 1
                ? (split[0][0] + split[split.length - 1][0]).toUpperCase()
                : split[0][0].toUpperCase();

            const color = generateVibrantColorFromName(name);
            context.fillStyle = color;
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.font = "16px Arial";
            context.fillStyle = "#fff";

            const textWidth = context.measureText(initials).width;
            const x = (canvas.width - textWidth) / 2;
            context.fillText(initials, x, 23);

            const data = canvas.toDataURL();
            document.body.removeChild(canvas);
            return data;
        } else {
            return "";
        }
    }
}
